import { useEffect, useState } from "react";

interface UseScrollVisibilityOptions {
  /** Ngưỡng scroll để ẩn element khi scroll xuống */
  hideThreshold?: number;
  /** Ngưỡng scroll để hiện element khi scroll lên */
  showThreshold?: number;
  /** Trạng thái hiển thị ban đầu */
  initialVisible?: boolean;
}

/**
 * Custom hook để quản lý hiển thị/ẩn element dựa trên scroll direction và position
 * @param options - Cấu hình cho hook
 * @returns isVisible - Trạng thái hiển thị của element
 */
const useScrollVisibility = ({
  hideThreshold = 80,
  showThreshold = 20,
  initialVisible = true,
}: UseScrollVisibilityOptions = {}) => {
  const [isVisible, setIsVisible] = useState(initialVisible);

  useEffect(() => {
    let lastScrollY = window.scrollY;
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;
          const scrollDirection = currentScrollY > lastScrollY ? "down" : "up";

          // Ẩn element khi scroll xuống và vượt ngưỡng
          if (
            scrollDirection === "down" &&
            currentScrollY > hideThreshold &&
            isVisible
          ) {
            setIsVisible(false);
          } 
          // Hiện element khi scroll lên và dưới ngưỡng
          else if (
            scrollDirection === "up" &&
            currentScrollY < showThreshold &&
            !isVisible
          ) {
            setIsVisible(true);
          }

          lastScrollY = currentScrollY;
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isVisible, hideThreshold, showThreshold]);

  return isVisible;
};

export default useScrollVisibility;